import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { forgotPassword } from '../api/auth';
import styles from './LoginPage.module.css';

const ForgotPasswordPage = () => {
  const location = useLocation();
  const [email, setEmail] = useState(() => new URLSearchParams(location.search).get('email') || '');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const res = await forgotPassword(email);
      setSuccess(res?.message || 'メールアドレスが登録されている場合、パスワード再設定リンクを送信しました。');
    } catch (err) {
      const msg = err?.response?.data?.message || '送信に失敗しました。時間をおいて再度お試しください。';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>パスワード再設定</h2>

      {error && <p className={styles.error}>{error}</p>}
      {success && <p>{success}</p>}

      <label htmlFor="forgot-email" style={{ display: 'block', marginBottom: 4 }}>メールアドレス</label>
      <input
        id="forgot-email"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="メールアドレス"
        style={{ display: 'block', marginBottom: '10px' }}
      />

      <button className={styles.loginButton} onClick={handleSubmit} disabled={loading}>
        {loading ? '送信中...' : '送信'}
      </button>

      <div className={styles.linkRow}>
        <Link to="/login" style={{ color: 'blue', textDecoration: 'underline' }}>
          ログインへ戻る
        </Link>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
